import React, { FC, useContext } from 'react';
import {
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TextField,
  TableContainer,
  makeStyles,
  MenuItem,
  Select,
  ListItemText,
  Checkbox
} from '@material-ui/core';
import { HeaderRow, TableCellHead, TableCustom } from 'components/Table';
import { dummyInvoice } from 'utils/dummy';
import BodyRow from './components/BodyRow';
import useRole from 'hooks/useRole';
import TypeUser from 'typings/enum/TypeUser';
import { CurrentUserContext } from 'contexts/CurrentUserContext';

interface Props {
  isLoadingData: boolean;
  count: number;
  currentPage: number;
  invoicePrint: number;
  invoices?: InvoiceModel[];
  order: 'asc' | 'desc';
  orderBy: string;
  indexCollapse: number;
  openCollapse: boolean;
  name: string;
  statusPayment: string;
  statusPrint: number;
  invoiceId: string;
  loadingItem: boolean;
  isRequestEdit: boolean;
  loadingPrint: boolean;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  zones: ZoneModel[];
  zone: number[];
  setZone: React.Dispatch<React.SetStateAction<number[]>>;
  setName: React.Dispatch<React.SetStateAction<string>>;
  setStatusPayment: React.Dispatch<React.SetStateAction<string>>;
  setStatusPrint: React.Dispatch<React.SetStateAction<number>>;
  handlePrintRequest: (id: number) => void;
  loadingPrintRequest: boolean;
  handlePrint: (id: number) => void;
  setInvoiceId: React.Dispatch<React.SetStateAction<string>>;
  setOrder: React.Dispatch<React.SetStateAction<'asc' | 'desc'>>;
  setOrderBy: React.Dispatch<React.SetStateAction<string>>;
  handleConfirmationDelete: (id: number) => React.MouseEventHandler;
  handleOpenCollapse: (index: number, id: number) => React.MouseEventHandler;
  salesName: string;
  setSalesName: React.Dispatch<React.SetStateAction<string>>;
}

const useStyles = makeStyles({
  cellStartId: {
    width: '10%'
  },
  cellTable: {
    width: '17%'
  },
  cellTable3: {
    width: '13%'
  },
  cellStatus: {
    width: 150,
    minWidth: 150
  },
  selectStatus: {
    width: '150px'
  }
});

const InvoiceTable: FC<Props> = props => {
  const { currentUser } = useContext(CurrentUserContext);

  const classes = useStyles();
  const {
    isLoadingData,
    loadingItem,
    invoices,
    order,
    orderBy,
    indexCollapse,
    openCollapse,
    name,
    handlePrintRequest,
    loadingPrintRequest,
    isRequestEdit,
    invoiceId,
    invoicePrint,
    statusPayment,
    statusPrint,
    isSuperAdmin,
    handlePrint,
    loadingPrint,
    isAdmin,
    setName,
    setStatusPayment,
    setStatusPrint,
    setInvoiceId,
    setOrder,
    setOrderBy,
    handleConfirmationDelete,
    handleOpenCollapse,
    zones,
    setZone,
    zone,
    salesName,
    setSalesName
  } = props;

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const isSuperVisor = useRole({
    type: (currentUser && currentUser.type) || 'SUPERVISOR',
    allowed: ['SUPERVISOR']
  });
  const adminInvoice = useRole({
    type: (currentUser && currentUser.type) || TypeUser.ADMIN03,
    allowed: [TypeUser.ADMIN03, TypeUser.HEAD_ADMIN_OPS]
  });

  return (
    <TableContainer>
      <TableCustom>
        <TableHead>
          {adminInvoice ? (
            <HeaderRow
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              headers={[
                { label: '#' },
                { label: 'No' },
                { id: 'invoiceNumber', label: 'Nomor Invoice', sort: true },
                { id: 'createdAt', label: 'Tgl Invoice', sort: true },
                { id: 'name', label: 'Nama Customer', sort: true },
                { id: 'statusPayment', label: 'Status', sort: true, align: 'center' },
                { id: 'zone', label: 'RUTE', sort: true, align: 'center' },
                { id: 'nameSales', label: 'NAMA SALES', sort: true },
                { id: 'totalPrice', label: 'Total Tagihan', sort: true },
                // { id: 'totalPay', label: 'Total Pembayaran', sort: true },
                { id: 'statusPrint', label: 'Status Print', sort: true }
              ]}
            />
          ) : (
            <HeaderRow
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              headers={[
                { label: '#' },
                { label: 'No' },
                { id: 'invoiceNumber', label: 'Nomor Invoice', sort: true },
                { id: 'createdAt', label: 'Tgl Invoice', sort: true },
                { id: 'name', label: 'Nama Customer', sort: true },
                { id: 'statusPayment', label: 'Status', sort: true, align: 'center' },
                { id: 'zone', label: 'RUTE', sort: true, align: 'center' },
                { id: 'nameSales', label: 'NAMA SALES', sort: true },
                { id: 'totalPrice', label: 'Total Tagihan', sort: true },
                // { id: 'totalPay', label: 'Total Pembayaran', sort: true },
                { label: '' }
              ]}
            />
          )}
          <TableRow>
            <TableCellHead variant='head' className={classes.cellTable} />
            <TableCellHead variant='head' className={classes.cellTable} />
            <TableCellHead variant='head' className={classes.cellStartId}>
              <TextField id='invoiceId' placeholder='Nomor Invoice' value={invoiceId} onChange={event => setInvoiceId(event.target.value)} />
            </TableCellHead>
            <TableCellHead variant='head' className={classes.cellTable} />
            <TableCellHead variant='head' className={classes.cellTable}>
              <TextField id='name' placeholder='Nama Customer' value={name} onChange={event => setName(event.target.value)} />
            </TableCellHead>
            <TableCellHead variant='head' className={classes.cellStatus}>
              <TextField
                select
                id='statusPayment'
                value={statusPayment}
                onChange={event => setStatusPayment(event.target.value as string)}
                className={classes.selectStatus}
              >
                <MenuItem selected key={1} value='' disabled>
                  Pilih Pembayaran
                </MenuItem>
                <MenuItem key={2} value='PAID'>
                  Lunas
                </MenuItem>
                <MenuItem key={3} value='UNPAID'>
                  Belum Lunas
                </MenuItem>
                {!isSuperVisor && (
                  <MenuItem key={4} value='CANCEL'>
                    Batal
                  </MenuItem>
                )}
              </TextField>
            </TableCellHead>

            <TableCellHead variant='head' className={classes.cellTable3}>
              <Select
                id='demo-mutiple-checkbox'
                margin='dense'
                multiple
                variant='outlined'
                fullWidth
                value={zone}
                onChange={e => setZone(e.target.value as number[])}
                renderValue={selected =>
                  `${zones
                    .filter(value => (selected as number[]).includes(value.id as number))
                    .map(value => value.name)
                    .join(',')
                    .substr(0, 8)}...`
                }
              >
                {zones.map(value => (
                  <MenuItem key={value.id} value={value.id}>
                    <Checkbox color='primary' checked={zone.indexOf(value.id) > -1} />
                    <ListItemText primary={value.name} />
                  </MenuItem>
                ))}
              </Select>
            </TableCellHead>

            <TableCellHead variant='head' className={classes.cellTable}>
              <TextField id='salesName' placeholder='Sales' value={salesName} onChange={event => setSalesName(event.target.value)} />
            </TableCellHead>

            <TableCellHead />
            <TableCellHead />
            {adminInvoice && (
              <TableCellHead variant='head' className={classes.cellTable3}>
                <TextField
                  id='statusPrint'
                  select
                  value={statusPrint}
                  onChange={event => setStatusPrint(+event.target.value)}
                  className={classes.selectStatus}
                >
                  <MenuItem selected key={1} value={0}>
                    Belum Print
                  </MenuItem>
                  <MenuItem key={2} value={1}>
                    Sudah Print
                  </MenuItem>
                </TextField>
              </TableCellHead>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoadingData ? (
            [0, 1, 2, 3].map(index => (
              <BodyRow
                key={index}
                index={index}
                isRequestEdit={isRequestEdit}
                indexCollapse={indexCollapse}
                openCollapse={openCollapse}
                isLoading={isLoadingData}
                invoicePrint={invoicePrint}
                invoice={dummyInvoice}
                handlePrint={handlePrint}
                loadingPrint={loadingPrint}
                handlePrintRequest={handlePrintRequest}
                loadingPrintRequest={loadingPrintRequest}
                adminInvoice={adminInvoice}
                isSuperAdmin={isSuperAdmin}
                statusPrint={statusPrint}
                isAdmin={isAdmin}
                onDelete={handleConfirmationDelete(0)}
                handleOpenCollapse={handleOpenCollapse(index, 0)}
                loadingItem={loadingItem}
              />
            ))
          ) : invoices && invoices.length > 0 ? (
            invoices.map((value, index) => (
              <BodyRow
                key={index}
                index={index}
                indexCollapse={indexCollapse}
                openCollapse={openCollapse}
                isLoading={isLoadingData}
                invoice={value}
                statusPrint={statusPrint}
                handlePrint={handlePrint}
                isRequestEdit={isRequestEdit}
                handlePrintRequest={handlePrintRequest}
                loadingPrintRequest={loadingPrintRequest}
                loadingPrint={loadingPrint}
                adminInvoice={adminInvoice}
                invoicePrint={invoicePrint}
                isSuperAdmin={isSuperAdmin}
                isAdmin={isAdmin}
                onDelete={handleConfirmationDelete(value.id)}
                handleOpenCollapse={handleOpenCollapse(index, value.id)}
                loadingItem={loadingItem}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={9} align='center'>
                Data Tidak Tersedia.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </TableCustom>
    </TableContainer>
  );
};

export default InvoiceTable;
